const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "/reco/api/chat"
    : "http://k8s-machinecraftmain-f16cc05195-1227403734.ap-northeast-3.elb.amazonaws.com/reco/api/chat";
const API_KEY = "reco-api-550e8400e29b41d4a716446655440000";

export interface ChatCard {
  id: string;
  title: string;
  price: number;
  why: string | null;
  link: string;
  image: string;
  badges: string[];
  meta: Record<string, any>;
  ai_score: number | null;
  ai_summary: string | null;
}
export interface ChatResponse {
  session_id: string;
  state: "NEED_CLARIFY" | "READY_FOR_SEARCH" | "COMPLETED";
  chips: string[];
  cards: ChatCard[];
  summary?: string;
  ask?: string;
}

export async function sendChatMessage(userText: string, sessionId?: string): Promise<ChatResponse> {
  const res = await fetch(BASE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": API_KEY,
    },
    body: JSON.stringify({
      user_text: userText,
      ...(sessionId ? { session_id: sessionId } : {}),
    }),
  });
  if (!res.ok) throw new Error("APIリクエストに失敗しました");
  return res.json();
}
